import { render, staticRenderFns } from "./PostFileUpload.vue?vue&type=template&id=eda7032c&"
import script from "./PostFileUpload.vue?vue&type=script&lang=js&"
export * from "./PostFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./PostFileUpload.vue?vue&type=style&index=0&id=eda7032c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports